var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('component-container',{attrs:{"object":_vm.object}},[_c('el-form',{ref:"object",attrs:{"model":_vm.object,"size":"mini"}},[_c('div',{staticClass:"un-support"},[_vm._v("\n      暂不支持，敬请期待\n    ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }